import '../css/main.scss';
import Filter from 'bad-words';

jQuery(document).ready(function($) {
  const GCS = window['GCS'] || {};
  const body = $('body');
  const header = $('.header');
  const screen_admin_min = 783;
  
  let adminBarHeight = 0;

  // Calculate admin bar
  if (body.hasClass('admin-bar')) {
    if ($(window).width() > screen_admin_min) {
      adminBarHeight = 32;
    } else {
      adminBarHeight = 46;
    }
  }

  // Go to element
  $.fn.goToElement = function(offset) {
    offset = 80;
    if ($(this).length) {
      var offsetTop = $(this).offset().top,
        args = {
          scrollTop: (offsetTop - adminBarHeight - offset)
        };
      $('html, body').animate(args, 'fast');
    }
    return this;
  };
  body.on('click', '.anchor-link', function(e) {
    var _this = $(this);
    if (0 === _this.attr('href').indexOf('#')) {
      e.preventDefault();
      $(_this.attr('href')).goToElement();
    }
  });

  // Window events
  var onWindowEvents = function(foo, isReady, isLoad, isResize, isScroll) {
    if (isReady) {
      $(document).ready(foo);
    }

    if (isLoad) {
      $(window).bind('load', foo);
    }

    if (isResize) {
      var throttleResizing = _.throttle(foo, 100);
      $(window).bind('resize', throttleResizing);
    }

    if (isScroll) {
      var throttleScroll = _.throttle(foo, 10);
      $(window).bind('scroll', throttleScroll);
    }
  };

  // Balance elements
  var balanceElements = function(container, clr, gapDelta) {
    clr = (typeof clr !== 'undefined' ? clr : false);
    gapDelta = (typeof gapDelta !== 'undefined' ? gapDelta : 10);
    var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = [],
      el,
      currentDiv,
      topPosition = 0;
    var c = $(container).filter(':visible');
    if (!c.length) {
      return false;
    }
    if (!clr) {
      c.css('height', 'auto');
    } else {
      c.removeAttr('style');
    }
    c.each(function() {
      el = $(this);
      topPosition = el.offset().top;
      if ((currentRowStart < (topPosition + gapDelta)) && (currentRowStart > (topPosition - gapDelta))) {
        rowDivs.push(el);
        currentTallest = (currentTallest < el.outerHeight()) ? (el.outerHeight()) : (currentTallest);
      } else {
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].css('height', currentTallest + 'px');
        }
        rowDivs.length = 0; // empty the array
        currentRowStart = topPosition;
        currentTallest = el.outerHeight();
        rowDivs.push(el);
      }
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].css('height', currentTallest + 'px');
      }
    });
    return true;
  };

  var balanceAll = function() {
    balanceElements($('.balance-elements'), false, 30);
  };

  onWindowEvents(balanceAll, 1, 1, 1, 0);

  // Mobile dropdown menu
  var toggleHtml = '<a href="#" class="dropdown-menu-toggle d-lg-none"><span></span></a>';
  header.find('.menu > li.menu-item-has-children > a').after(toggleHtml);
  $(document).on('click', '.dropdown-menu-toggle, .dropdown-menu-toggle + a', function(e) {
    if ($(window).width() < 992) {
      e.preventDefault();
      $(this).closest('.menu-item-has-children').find('.dropdown-menu-toggle').toggleClass('toggle');
      $(this).closest('.menu-item-has-children').children('ul').slideToggle();
    }
  });

  // Search
  $(document).on('click', '.mobile-search-trigger', function(e) {
    e.preventDefault();
    body.toggleClass('search-mobile-open');
  });

  $(document).on('click', '.desktop-search-trigger', function(e) {
    e.preventDefault();
    body.toggleClass('search-desktop-open');

    setTimeout(function() {
      if (body.hasClass('search-desktop-open')) {
        header.find('.aws-search-field').focus();
      }
    }, 200);
  });

  const hideSearch = () => {
    header.find('.side-menu').css('position', 'relative');
    body.removeClass('search-desktop-open');

    setTimeout(function() {
      header.find('.side-menu').css('position', '');
    }, 500);
  };

  $(document).keyup(function(e) {
    if (e.key === 'Escape') { // escape key maps to keycode `27`
      hideSearch();
    }
  });

  header.find('.aws-search-field').on('blur', hideSearch);

  // Header menu item hover
  header.find('.menu > li').hoverIntent({
    over: function() {
      $(this).addClass('hover');
    }, out: function() {
      $(this).removeClass('hover');
    }, timeout: 200
  });

  // Side menu
  header.on('click', '.side-menu-toggle', function(e) {
    e.preventDefault();
    if (body.hasClass('side-menu-open')) {
      body.addClass('side-menu-closing');
      setTimeout(function() {
        body.removeClass('side-menu-open side-menu-closing');
        $('html').removeClass('side-menu-open');
      }, 400);
    } else {
      body.addClass('side-menu-open');
      $('html').addClass('side-menu-open');
    }
  });

  // Shop page
  $(document).on('yith-wcan-ajax-loading', function() {
    body.addClass('yith-wcan-ajax-loading');
    $('#content').goToElement();
  }).on('yith-wcan-ajax-filtered', function() {
    body.removeClass('yith-wcan-ajax-loading');
  });

  // Checkout
  var togglePaymentGroup = function() {
    body.find('.hidden-on-payment').fadeToggle(200, function() {
      body.find('.shown-on-payment').fadeToggle(200);
    });

    $('.section-woo-nav .last-step').toggleClass('active');
  };
  $(document).on('click', '.toggle-payment-groups', function(e) {
    e.preventDefault();

    var multiShippingAddresses = $('.ywcmas_addresses_manager_table_shipping_address_select');
    var valid = true;

    if ($('#ywcmas_manage_addresses_cb').is(':checked') && multiShippingAddresses.length) {
      multiShippingAddresses.each(function() {
        if ('gcs_empty_address' === $(this).val() || _.isNull($(this).val())) {
          $(this).parent().addClass('invalid');
          valid = false;
        } else {
          $(this).parent().removeClass('invalid');
        }
      });
    }

    if (valid) {
      body.goToElement();

      togglePaymentGroup();
    } else {
      alert('Please select a delivery address for each cards group');
    }
  });

  $(document.body).on('checkout_error', function() {
    if ($('.hidden-on-payment .woocommerce-invalid').length) {
      togglePaymentGroup();
    }
  });

  $(document.body).on('click', 'a.showlogin', togglePaymentGroup);

  body.on('blur change', '.woocommerce-checkout .input-text', function() {
    var wrapper = $(this).closest('.form-row');

    if ((wrapper.hasClass('validate-required') && !$(this).val()) || (/[#&\\|%^~`’]+/.test($(this).val()))) {
      wrapper.removeClass('woocommerce-validated');
      wrapper.addClass('woocommerce-invalid');
    } else {
      wrapper.removeClass('woocommerce-invalid');

      if (wrapper.hasClass('validate-required')) {
        wrapper.addClass('woocommerce-validated');
      } else {
        wrapper.removeClass('woocommerce-validated');
      }
    }
  });

  body.on('blur change', '#billing_phone, #shipping_phone', function() {
    var wrapper = $(this).closest('.form-row');
    const digitalCardRecipientPhone = $('dd.variation-Recipientmobilephone');

    if (
      !(/^0[^\s]{9}$/.test($(this).val())) ||
      (digitalCardRecipientPhone.length && (digitalCardRecipientPhone.text().replace(/[^\d]/g, '').slice(-10) === $(this).val().slice(-10)))
    ) {
      wrapper.removeClass('woocommerce-validated');
      wrapper.addClass('woocommerce-invalid');
    } else {
      wrapper.removeClass('woocommerce-invalid');

      if (wrapper.hasClass('validate-required')) {
        wrapper.addClass('woocommerce-validated');
      } else {
        wrapper.removeClass('woocommerce-validated');
      }
    }
  });

  body.on('blur input focus', '.gift-cards_form #ywgc-manual-amount', function() {
    const _this = $(this);
    const obj = $(this)[0];
    const val = _this.val();

    if (val && parseInt(val) > 25) {
      if (!obj.checkValidity()) {
        _this.addClass('invalid');
        if (_this.attr('max')) {
          _this.val(_this.attr('max'));
        }
      } else {
        _this.removeClass('invalid');
      }
    } else {
      _this.removeClass('invalid');
    }
  });

  $(document.body).on('update_checkout', function() {
    if ($('.ywcmas_shipping_address_button_new').length) {
      $(document.body).trigger('ywcmas_init_pp', 'checkout');
    }
  });

  var wrapPaymentSelect = function() {
    $('#payment').find('select').each(function() {
      if (!$(this).parent().hasClass('select-holder')) {
        $(this).wrap('<div class="select-holder"></div>');
      }
    });
  };
  $(document.body).bind('updated_checkout', wrapPaymentSelect);

  // Single product
  if (body.hasClass('single-product-virtual')) {
    $(document).on('yith_wacp_popup_after_opening', function() {
      window.location.href = '/cart/';
    });
  }

  // Cart
  var triggerTooltips = function() {
    $('[data-toggle="tooltip"]').tooltip();
  };
  var is_blocked = function($node) {
    return $node.is('.processing') || $node.parents('.processing').length;
  };
  var unblock = function($node) {
    $node.removeClass('processing').unblock();
  };
  var block = function($node) {
    if (!is_blocked($node)) {
      $node.addClass('processing').block({
        message: null,
        overlayCSS: {
          background: '#fff',
          opacity: 0.6
        }
      });
    }
  };
  $(document).on(
    'change',
    'select.shipping_method, :input[name^=shipping_method]',
    function() {
      block($('.section-shipping-methods'));
    }
  );
  $(document.body).on('updated_shipping_method', function() {
    unblock($('.section-shipping-methods'));

    // Trigger updating cart
    $('[name="update_cart"]').prop('disabled', false).trigger('click');
  });
  $(document.body).on('updated_wc_div updated_checkout gcs_add_recipient', triggerTooltips);

  // Load cart count
  $.ajax({
    method: 'GET',
    url: GCS.ajaxUrl,
    dataType: 'json',
    data: {
      action: 'load_ajax_header_cart_count'
    }
  }).done(function(response) {
    if (response.success && response.data.html) {
      $('.ajax-header-cart-count').html(response.data.html).fadeIn();
    }
  });

  // Hide Undo link on cart
  $(document.body).on('updated_wc_div', function() {
    $('.woocommerce-message .restore-item').remove();
  });

  // Validate gift card message
  // $('textarea').on('input change propertychange', function() {
  //   var errorMessage = 'Please match the requested format.';
  //
  //   var patternRegex = new RegExp('[^a-zA-Z0-9\s\,\.\‘\–\/]', 'g');
  //   var hasError = null !== $(this).val().match(patternRegex);
  //
  //   if (typeof this.setCustomValidity === 'function') {
  //     this.setCustomValidity(hasError ? errorMessage : '');
  //   }
  //   else {
  //     $(this).toggleClass('error', !!hasError);
  //     $(this).toggleClass('ok', !hasError);
  //
  //     if (hasError) {
  //       $(this).attr('title', errorMessage);
  //     }
  //     else {
  //       $(this).removeAttr('title');
  //     }
  //   }
  // });

  triggerTooltips();

  // Confirm email on VGC
  function validateEmail(email) {
    var test_email = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'i');
    return test_email.test(email);
  }

  function validatePhone(phone) {
    var test_phone = new RegExp(/^(?:(61))? ?(?:((?=.*)))?(0?[4]) ?(\d\d(?:- |(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/, 'i');
    return test_phone.test(phone);
  }

  function isPhoneFieldValid(phoneField) {
    if (phoneField.val() && !validatePhone(phoneField.val())) {
      phoneField.val(phoneField.val().trim());

      phoneField.closest('.ywgc-single-recipient').find('input[name="ywgc-recipient-phone[]"]').removeClass('invalid');
      phoneField.addClass('invalid');
      phoneField.closest('.ywgc-single-recipient').find('.ywgc-bad-email-format').remove();
      phoneField.after('<span class="ywgc-bad-email-format">Please enter a valid Australian mobile phone number</span>');

      return false;

    } else if ($('.ywgc-recipient-phone-confirm-phone').length) {

      const confirmPhone = phoneField.closest('.ywgc-single-recipient').find('.ywgc-recipient-phone-confirm-phone');

      confirmPhone.val(confirmPhone.val().trim());

      if (confirmPhone.val() && phoneField.val().trim().toLowerCase() !== confirmPhone.val().trim().toLowerCase()) {
        phoneField.closest('.ywgc-single-recipient').find('.invalid').removeClass('invalid');
        confirmPhone.addClass('invalid');
        phoneField.closest('.ywgc-single-recipient').find('.ywgc-bad-email-format').remove();
        phoneField.after('<span class="ywgc-bad-email-format">Mobile phone and Confirm mobile phone are not matched</span>');

        return false;
      }
    }

    phoneField.closest('.ywgc-single-recipient').find('.ywgc-bad-email-format').remove();
    phoneField.closest('.ywgc-single-recipient').find('input[name="ywgc-recipient-phone[]"]').removeClass('invalid');
    phoneField.closest('.ywgc-single-recipient').find('.invalid').removeClass('invalid');

    return true;
  }

  function isOffensiveText(value) {
    const Filter = require('bad-words');
    const filter = new Filter({placeHolder: 'x', exclude: ['wang']});

    if (filter.isProfane(value)) {
      return true;
    }

    return false;
  }
  
  function isFieldNotOffensive(field) {
    field.val(field.val().trim());

    field.parent().find('.ywgc-bad-email-format').remove();
    field.removeClass('invalid');

    if (field.val()) {
      if (isOffensiveText(field.val())) {
        field.addClass('invalid');
        field.after('<span class="ywgc-bad-email-format">The field contains offensive words, please kindly remove before continuing.</span>');

        return false;
      }
    }

    return true;
  }

  $(document).on('click', 'form.gift-cards_form button.gift_card_add_to_cart_button', function(e) {
    if ($('.ywgc-recipient').length) {
      var canSubmit = true;

      $('.ywgc-single-recipient input[name="ywgc-recipient-email[]"]').each(function(i, obj) {
        if ($(this).val() && !validateEmail($(this).val())) {
          $(this).val($(this).val().trim());

          $(this).closest('.ywgc-single-recipient').find('input[name="ywgc-recipient-email[]"]').removeClass('invalid');
          $(this).addClass('invalid');
          $(this).closest('.ywgc-single-recipient').find('.ywgc-bad-email-format').remove();
          $(this).after('<span class="ywgc-bad-email-format">Please enter a valid email address</span>');
          canSubmit = false;

        } else if ($('.ywgc-recipient-email-confirm-email').length) {

          const confirmEmail = $(this).closest('.ywgc-single-recipient').find('.ywgc-recipient-email-confirm-email');
          confirmEmail.val(confirmEmail.val().trim());

          if ($(this).val().trim().toLowerCase() !== confirmEmail.val().trim().toLowerCase()) {
            $(this).closest('.ywgc-single-recipient').find('.invalid').removeClass('invalid');
            confirmEmail.addClass('invalid');
            $(this).closest('.ywgc-single-recipient').find('.ywgc-bad-email-format').remove();
            $(this).after('<span class="ywgc-bad-email-format">Email and Confirm email are not matched</span>');
            canSubmit = false;
          }

        }
      });

      $('.ywgc-single-recipient input[name="ywgc-recipient-phone[]"]').each(function(i, obj) {
        canSubmit = canSubmit && isPhoneFieldValid($(this));
      });

      // Cleanup
      $('[name="ywgc-recipient-name[]"], [name="ywgc-sender-name"], [name="ywgc-edit-message"]').each(function() {
        canSubmit = canSubmit && isFieldNotOffensive($(this));
      });

      if (!canSubmit) {
        return false;
      }
    }
  });

  $(document).on('blur', '.ywgc-single-recipient input[name="ywgc-recipient-phone[]"], .ywgc-recipient-phone-confirm-phone', function() {
    isPhoneFieldValid($('.ywgc-single-recipient input[name="ywgc-recipient-phone[]"]'));
  });

  $(document).on('blur', '[name="ywgc-recipient-name[]"], [name="ywgc-sender-name"], [name="ywgc-edit-message"]', function() {
    isFieldNotOffensive($(this));
  });

  // Create account password on checkout
  let passwordTimeout;
  $(document).on('input', '[name="account_password"]', function() {
    const _this = $(this);

    clearTimeout(passwordTimeout);

    passwordTimeout = setTimeout(function() {
      const passwordStrength = $('.woocommerce-password-strength');
      if (
        _this.val().length < 3 ||
        passwordStrength.hasClass('short') ||
        (passwordStrength.hasClass('bad') && 'weak' !== passwordStrength.text().toLowerCase())
      ) {
        $('.confirm-create-account').prop('disabled', true);
      } else {
        $('.confirm-create-account').prop('disabled', false);
      }
    }, 500);
  }).on('click', '.confirm-create-account', function(e) {
    e.preventDefault();
    var accountPassword = $('[name="account_password"]');
    if (accountPassword.prop('readonly')) {
      $(this).text('Confirm');
      accountPassword.prop('readonly', false);
    } else {
      $(this).text('Unconfirm');
      accountPassword.prop('readonly', true);
    }
  });

  // Update GCS object
  GCS.isOffensiveText = isOffensiveText;

  // No other code should be added below this line
  window['GCS'] = GCS;
});
